<div class="help-drawer-tab-content-container">
  <!-- Tab's Primary Content -->
  <!-- Since we're using accordions to render the ownership content now; ownership tab content don't have headers/mainContent -->
  <div *ngIf="tabContent.header" class="help-drawer-tab-primary-content">
    <h3 class="c11n-text-lg-headline">{{ tabContent.header }}</h3>
    <p class="c11n-text-sm">{{ tabContent.mainContent }}</p>
  </div>

  <!-- Tab's Secondary/Sub Content -->
  <!-- The content inside of this div is all conditionally rendered based on if the related content exists-->
  <!-- Using first & ngClass to render the border-top for ONLY the first subContent element rendered -->
  <div
    *ngFor="let subContent of tabContent.subContent; let first = first"
    class="help-drawer-tab-sub-content"
    [ngClass]="!tabContent.header && first ? 'help-drawer-tab-border-top' : ''"
  >
    <!-- For reference, if anyone is wondering why we don't have another "headline" class (e.g. c11n-text-md-headline), c11n-text-lg-headline is currently the smallest headline class-->
    <h4 class="c11n-text-md-bold">{{ subContent.subheader }}</h4>

    <!-- Sub Content -->
    <p *ngIf="subContent.content" class="c11n-text-sm">{{ subContent.content }}</p>

    <!-- Bullet Points -->
    <ul *ngIf="subContent.bulletPoints?.length" class="c11n-text-sm">
      <li *ngFor="let bulletPoint of subContent.bulletPoints">
        <ng-container *ngIf="formatBulletPointText(bulletPoint) as formattedText">
          <strong *ngIf="formattedText.hasDelimiter">{{ formattedText.boldText }}</strong
          >{{ formattedText.normalText }}
        </ng-container>
      </li>
    </ul>

    <!-- TODO: Inside of the help-drawer-content.json file, there's a section called __futureContent__; when we re-add the additionalContent & additionalBulletPoints for trusts OR if we ever get different additionalContent|bulletPoints, then uncomment these please-->
    <!-- additionalContent & additionalBulletPoints; they currently only exist for trusts -->
    <!--    <p *ngIf="subContent.additionalContent" class="c11n-text-sm" >{{  subContent.additionalContent }}</p>-->

    <!--    <ul *ngIf="subContent.additionalBulletPoints?.length" class="c11n-text-sm">-->
    <!--      <li *ngFor="let bulletPoint of subContent.additionalBulletPoints">-->
    <!--        <ng-container *ngIf="formatBulletPointText(bulletPoint) as formattedText">-->
    <!--          <strong *ngIf="formattedText.hasDelimiter">{{ formattedText.boldText }}</strong>{{ formattedText.normalText }}-->
    <!--          </ng-container>-->
    <!--      </li>-->
    <!--    </ul>-->
  </div>
</div>
